"use client"
import { useState, useEffect } from "react"
import { useParams, Link } from "react-router-dom"
import axios from "axios"

const ViewOrder = () => {
  const { orderId } = useParams()
  const [orderDetails, setOrderDetails] = useState(null)
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchOrderDetails()
    fetchItems()
  }, [])

  const fetchOrderDetails = async () => {
    try {
      const res = await axios.get(
        `https://logicx.premierlam.com/api/pixel-get-all-the-details-of-particular-order/${orderId}`,
        { headers: { authorization: localStorage.getItem("accessToken") } }
      )
      setOrderDetails(res.data.data[0])
    } catch (err) {
      console.log(err)
    }
  }

  const fetchItems = async () => {
    try {
      setLoading(true)
      const res = await axios.get(
        `https://logicx.premierlam.com/api/pixel-get-items/${orderId}`,
        { headers: { authorization: localStorage.getItem("accessToken") } }
      )
      setItems(res.data.data || [])
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  if (!orderDetails) return <div className="p-10 text-center">Loading...</div>
  const renderLink = (url) => {
    if (!url) return "Not Set";

    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 underline hover:text-blue-800"
      >
        {url}
      </a>
    );
  };

  return (
    <div className="p-6 bg-gray-50 overflow-y-auto min-h-screen">
      <div className="max-w-5xl mx-auto bg-white p-6 rounded-lg shadow-sm border">

        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-semibold text-gray-800">Order Details</h1>
          <Link to="/all-order"
            className="bg-gray-800 hover:bg-gray-900 text-white px-4 py-2 rounded-md">
            Back
          </Link>
        </div>

        {/* ORDER DETAILS */}
        <div className="grid grid-cols-2 gap-4 mb-6 text-sm">
          {Object.entries(orderDetails)
            .filter(([key]) => key !== "order_details" && key !== "order_comments") // ❗ exclude last two
            .map(([key, value]) => (
              <div key={key} className="border p-3 rounded bg-gray-50">
                <strong className="text-gray-700 capitalize">
                  {key.replace(/_/g, " ")}:
                </strong>
                &nbsp;
                {/* <span className="text-gray-900">{value || "Not Set"}</span>
                 */}
                <span className="text-gray-900">
                  {key === "invoice_link" ||
                    key === "tracking_link" ||
                    key === "customer_whatsapp_link" ||
                    key === "shipping_label"
                    ? renderLink(value)
                    : key === "phone_number" ? (
                      <a
                        href={`tel:${value}`}
                        className="text-blue-600 underline hover:text-blue-800"
                      >
                        {value}
                      </a>
                    ) : (
                      value || "Not Set")}
                </span>

              </div>
            ))}
        </div>

        {/* FULL WIDTH ORDER DETAILS */}
        <div className="mb-4 p-4 border rounded bg-gray-50 text-sm">
          <strong className="text-gray-700">Order Details:</strong>
          <p className="mt-1 text-gray-900 whitespace-pre-line">
            {orderDetails.order_details || "Not Set"}
          </p>
        </div>

        {/* FULL WIDTH ORDER COMMENTS */}
        <div className="mb-6 p-4 border rounded bg-gray-50 text-sm">
          <strong className="text-gray-700">Order Comments:</strong>
          <p className="mt-1 text-gray-900 whitespace-pre-line">
            {orderDetails.order_comments || "Not Set"}
          </p>
        </div>


        <h2 className="text-lg mb-3 font-semibold text-gray-700">Items in this Order</h2>

        {/* ITEMS TABLE */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr className="border-b text-gray-600">

                <th className="py-2 px-3 text-left">Image</th>
                <th className="py-2 px-3 text-left">ID</th>
                <th className="py-2 px-3 text-left">Created At</th>

                <th className="py-2 px-3 text-left">Code</th>
                <th className="py-2 px-3 text-left">Name</th>
                <th className="py-2 px-3 text-left">Material</th>
                <th className="py-2 px-3 text-left">Category</th>
                <th className="py-2 px-3 text-left">Color</th>
                <th className="py-2 px-3 text-left">SKU</th>

                <th className="py-2 px-3 text-left">Product Link</th>
                <th className="py-2 px-3 text-left">Order ID</th>
                <th className="py-2 px-3 text-left">Added By</th>
                <th className="py-2 px-3 text-left">Order Date</th>

                <th className="py-2 px-3 text-left">Selling Price</th>
                <th className="py-2 px-3 text-left">Unit Price</th>
                <th className="py-2 px-3 text-left">Qty</th>
                <th className="py-2 px-3 text-left">Discount</th>
                <th className="py-2 px-3 text-left">Amount</th>
                <th className="py-2 px-3 text-left">GST</th>
                <th className="py-2 px-3 text-left">Total</th>
                <th className="py-2 px-3 text-left">HSN</th>

                <th className="py-2 px-3 text-left">Original Name</th>
                <th className="py-2 px-3 text-left">Item Details</th>

                <th className="py-2 px-3 text-left">Unique Code</th>

              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr><td className="text-center py-5" colSpan={25}>Loading...</td></tr>
              ) : items.map((i) => (
                <tr key={i.id} className="border-b hover:bg-gray-50">

                  {/* IMAGE */}
                  <td className="py-2 px-3">
                    {i.vendor_image ? (
                      <a href={i.vendor_image} target="_blank" rel="noopener noreferrer">
                        <img
                          src={i.vendor_image}
                          className="h-14 w-14 object-cover rounded border cursor-pointer"
                        />
                      </a>
                    ) : (
                      <span className="text-gray-400 text-xs">No Image</span>
                    )}
                  </td>


                  <td className="py-2 px-3">{i.id}</td>
                  <td className="py-2 px-3">{i.created_at}</td>

                  <td className="py-2 px-3">{i.product_code}</td>
                  <td className="py-2 px-3">{i.product_name}</td>
                  <td className="py-2 px-3">{i.product_material}</td>
                  <td className="py-2 px-3">{i.product_category}</td>
                  <td className="py-2 px-3">{i.product_color}</td>
                  <td className="py-2 px-3">{i.product_sku}</td>

                  <td className="py-2 px-3">{i.product_link}</td>
                  <td className="py-2 px-3">{i.order_id}</td>
                  <td className="py-2 px-3">{i.added_by}</td>
                  <td className="py-2 px-3">{i.order_date}</td>

                  <td className="py-2 px-3">{i.selling_price}</td>
                  <td className="py-2 px-3">{i.unit_price}</td>
                  <td className="py-2 px-3">{i.qty}</td>
                  <td className="py-2 px-3">{i.discount}</td>
                  <td className="py-2 px-3">{i.amount}</td>
                  <td className="py-2 px-3">{i.taxes}</td>
                  <td className="py-2 px-3">{i.total_amount}</td>
                  <td className="py-2 px-3">{i.hsn_code}</td>

                  <td className="py-2 px-3">{i.item_original_name}</td>

                  <td className="py-2 px-3">
                    {i.item_details?.length > 25
                      ? i.item_details.substring(0, 25) + "..."
                      : i.item_details}
                  </td>

                  <td className="py-2 px-3">{i.product_unique_code}</td>

                </tr>
              ))}
            </tbody>

          </table>
        </div>



      </div>
    </div>
  )
}

export default ViewOrder
